import { Extension } from '@tiptap/core';

const INDENT_PX = 24;
const MAX_INDENT = 240;

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        paragraphIndent: {
            indentBlock: () => ReturnType;
            outdentBlock: () => ReturnType;
        };
    }
}

export const ParagraphIndent = Extension.create({
    name: 'paragraphIndent',

    addOptions() {
        return {
            types: ['paragraph', 'heading']
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    indent: {
                        default: 0,
                        parseHTML: (element: HTMLElement) => {
                            const ml = element.style.marginLeft || '0';
                            const px = parseInt(ml, 10) || 0;
                            return px;
                        },
                        renderHTML: (attributes: any) => {
                            if (!attributes.indent || attributes.indent === 0) {
                                return {};
                            }
                            return { style: `margin-left: ${attributes.indent}px` };
                        }
                    }
                }
            }
        ];
    },

    addCommands() {
        return {
            indentBlock:
                () =>
                    ({ state, tr, dispatch }: any) => {
                        let updated = false;
                        const { from, to } = state.selection;
                        state.doc.nodesBetween(from, to, (node: any, pos: number) => {
                            if (this.options.types.indexOf(node.type.name) !== -1) {
                                const current = node.attrs.indent || 0;
                                const next = Math.min(current + INDENT_PX, MAX_INDENT);
                                if (next !== current) {
                                    if (dispatch) {
                                        tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: next });
                                    }
                                    updated = true;
                                }
                            }
                            return true;
                        });
                        return updated;
                    },
            outdentBlock:
                () =>
                    ({ state, tr, dispatch }: any) => {
                        let updated = false;
                        const { from, to } = state.selection;
                        state.doc.nodesBetween(from, to, (node: any, pos: number) => {
                            if (this.options.types.indexOf(node.type.name) !== -1) {
                                const current = node.attrs.indent || 0;
                                const next = Math.max(current - INDENT_PX, 0);
                                if (next !== current) {
                                    if (dispatch) {
                                        tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: next });
                                    }
                                    updated = true;
                                }
                            }
                            return true;
                        });
                        return updated;
                    }
        } as any;
    }
});
